import { Injectable, inject } from '@angular/core';
import { AppActions } from '@navfleet/client/core/app';
import { FleetActions } from '@navfleet/client/fleet/domain/data-access';
import { VesselDestinationActions } from '@navfleet/client/monitoring/state/vessel-destination';
import { VesselNavStatusActions } from '@navfleet/client/monitoring/state/vessel-nav-status';
import { VesselPassageActions } from '@navfleet/client/monitoring/state/vessel-passage';
import { VesselRouteActions } from '@navfleet/client/monitoring/state/vessel-route';
import { PortActions } from '@navfleet/client/port/domain/data-access';
import { VesselActions } from '@navfleet/client/vessel/domain/data-access';
import { VesselTrackActions } from '@navfleet/client/vessel/track/domain/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';

@Injectable()
export class RootEffects {
    private readonly actions$ = inject(Actions);

    /**
     * Initial load of data needed after login
     */
    public readonly initLoadApplicationData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.loadAppData),
            mergeMap(() => [
                FleetActions.loadFleets(),
                VesselActions.loadVessels(),
                VesselDestinationActions.loadLatestDestinations({}),
                VesselNavStatusActions.initLoadOfVesselNavStatus({}),
                VesselPassageActions.loadAllActivePassages(),
                VesselRouteActions.initLoadOfVesselRoutes({ navigated: true }),
                VesselTrackActions.initLoadOfLatestVesselTrack({ all: true }),
                PortActions.initLoadOfPorts({}),
            ])
        )
    );
}
